import React, { FC, ChangeEvent } from 'react'
import { Box } from '@chakra-ui/core'
import {
  DetailRowWithCheckBox } from '@engyalo/storefront-components'
import { IProductLevel3 } from '@engyalo/storefront-types/lib/plugins/model'
import { ILevel3Props } from './types'

export const CheckCustomization: FC<ILevel3Props> = ({
  data, customizationSelected, setCustomizationSelected, deleteCustomizationSelected, currency
}: ILevel3Props) => {

  const onChangedValue = (event: ChangeEvent<HTMLInputElement>): void => {
    if (event.target) {
      if (event.target.checked) {
        setCustomizationSelected({
          ...data,
          quantity: 1
        } as IProductLevel3)
      } else {
        if (deleteCustomizationSelected) {
          deleteCustomizationSelected({
            ...data,
            quantity: 0
          } as IProductLevel3)
        }
      }
    }
  }

  if (data) {

    const {
      id: level3Id,
      name: level3Name,
      price
    } = data

    const getValue = (elementId: string | null): boolean => {
      if (elementId) {
        const value = customizationSelected[elementId]
        if (value) {
          return value.quantity === 1
        }
      }
      return false
    }

    let priceText = undefined
    if (price && price > 0) {
      priceText = `+ ${currency} ${price.toFixed(2)}`
    }

    return (
      <Box>
        {
          (level3Id && level3Name) &&
          (
            <DetailRowWithCheckBox
              value={level3Id}
              key={level3Id}
              title={level3Name}
              subTitle={priceText}
              name="food"
              onChange={onChangedValue}
              checked={getValue(level3Id)}
            />
          )
        }
      </Box>
    )
  }

  return null
}
